import React, { PureComponent } from 'react';
import {
  CheckBoxUnchecked,
  CheckBoxChecked,
} from 'AppSrc/core/components/common/svg-icons';
import PropTypes from 'prop-types';
import { OptionButton } from 'AppSrc/core/components/utility/option-button';
import { FieldTitle } from './sub-components/field-title';
import { InlineErrors } from './sub-components/inline-errors';
import {
  vFParamsPropShape,
  vFButtonSelectorOptionShape,
} from './data-structure/v-f-proptypes';
import 'AppSrc/core/style/components/form/form-base-components/v-f-multi-select.css';





class VFRadioButtonBase extends PureComponent {
  constructor(props) {
    super(props);
    this.updateValue = this.updateValue.bind(this);
  }


  updateValue(valueToAdd) {
    const {
      value,
      setValue,
    } = this.props;

    if (value === valueToAdd) {
      setValue(null);
      return null;
    }

    setValue(valueToAdd);
    return null;
  }


  render() {

    const {
      displayOptions,
      readOnly,
      optional,
      vFParams,
      name,
      value,
      errors,
      touched,
      displayText,
    } = this.props;

    const {
      fieldTitle,
      displayType,
      disabledFieldOptions = [],
    } = vFParams;


    // We don't display the field title if the display is 'big'
    // However we still need to provide a field title for the summary page
    const displayFieldTitle = fieldTitle && displayType !== 'big';

    const displayClassName = displayType ? displayType : 'standard';




    const {
      disabled,
    } = disabledFieldOptions;

    const inlineErrors = errors && errors.inlineErrors ? errors.inlineErrors : null;

    const classNameBase = 'v-f-radio-buttons';

    const classNameList = [
      'v-f-field-type',
      classNameBase,
      `${classNameBase}-${displayClassName}`,
      `${classNameBase}-${name}`,
    ];

    if (disabled) {
      classNameList.push(`${classNameBase}-disabled`);
    }
    if (readOnly) {
      classNameList.push(`${classNameBase}-read-only`);
    }

    const className = classNameList.join(' ');



    return (
      <div
        className={className}
        name={name}
      >
        {
          displayFieldTitle && (
            <FieldTitle
              fieldTitle={fieldTitle}
              optional={optional}
            />
          )
        }
        <div className="multi-select-body">
          <div className="display-value">
            <span>{displayText}</span>
          </div>
          <ul className="multi-select-options">
            {
              displayOptions.map((displayOption) => {
                const isSelected = value === displayOption.value;
                const baseCssClass = 'multi-select-option';
                const cssClasses = [baseCssClass];
                if (isSelected) { cssClasses.push(`${baseCssClass}-selected`); }
                return (
                  <li
                    key={displayOption.value}
                  >
                    <OptionButton
                      className={cssClasses.join(' ')}
                      onClick={this.updateValue}
                      option={displayOption.value}
                    >
                      <div className="svg-container">
                        {isSelected ? <CheckBoxChecked /> : <CheckBoxUnchecked />}
                      </div>
                      <p className="multi-select-option-text">
                        {displayOption.text}
                      </p>
                    </OptionButton>
                  </li>
                );
              })
            }
          </ul>
        </div>

        {
          inlineErrors && touched && (
            <InlineErrors
              inlineErrors={inlineErrors}
            />
          )
        }
      </div>
    );
  }
}



VFRadioButtonBase.propTypes = {
  vFParams: vFParamsPropShape,
  displayOptions: PropTypes.arrayOf(vFButtonSelectorOptionShape),
  readOnly: PropTypes.bool,
  optional: PropTypes.bool,
  setValue: PropTypes.func,
  value: PropTypes.string,
  name: PropTypes.string,
  errors: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
  touched: PropTypes.bool,
  displayText: PropTypes.string,
};




export {
  VFRadioButtonBase,
};
